import './digitalData'
import './scss/main.scss'

import { useEffect } from 'react'
import { useNavigate } from 'react-router'
import { Layout } from 'antd'

import B2becSpinner from './components/B2becSpinner'
import { ActionsDispatcher, SAPDownTime } from './components/PostAuthentication'
import ScrollToTop from './components/ScrollToTop'
import AddProductToWishListModal from './components/Wishlist/AddProductToWishlistModal'
import useCalculateScrollbarWidth from './hooks/useCalculateScrollbarWidth'
import useCheckForRedirectUrlAfterLogin from './hooks/useCheckForRedirectUrlAfterLogin'
import { setDateFormat } from './libs/utils/dateUtils'
import RouterRenderer from './routes'
import { useAppDispatch, useAppSelector } from './store/hook'
import { selectDateFormat } from './store/selectors/configSelector'
import { selectIsFetchingUserAssignedRoles } from './store/selectors/roleSelector'
import { selectIsAddProductToWishlistModalVisible } from './store/selectors/wishlistSelectors'
import {
  authenticationActions,
  selectIsCheckingAuthentication,
  selectIsLoggedIn,
} from './store/slices/authenticationSlice'
import { selectIsCurrentTimeInSAPDowntime } from './store/slices/configSlice'
import { selectIsFetchingSetupData } from './store/slices/setupSlice'

const App = () => {
  const dispatch = useAppDispatch()
  const navigate = useNavigate()
  const isCheckingAuthentication = useAppSelector(selectIsCheckingAuthentication)
  const isLoggedIn = useAppSelector(selectIsLoggedIn)
  const isAddProductToWishlistModalVisible = useAppSelector(
    selectIsAddProductToWishlistModalVisible,
  )
  const shouldShowSAPDownTimePopup = useAppSelector(selectIsCurrentTimeInSAPDowntime)
  const isFetchingSetupData = useAppSelector(selectIsFetchingSetupData)
  const dateFormat = useAppSelector(selectDateFormat)
  const isFetchingUserAssignedRoles = useAppSelector(selectIsFetchingUserAssignedRoles)

  setDateFormat(dateFormat)
  useCheckForRedirectUrlAfterLogin()
  useCalculateScrollbarWidth()

  useEffect(() => {
    dispatch(authenticationActions.checkAuthentication({ navigate }))
  }, [dispatch])

  if (isCheckingAuthentication || isFetchingSetupData || isFetchingUserAssignedRoles) {
    return <B2becSpinner isLoading />
  }

  return (
    <Layout style={{ backgroundColor: '#fff', minHeight: '100vh' }}>
      {isLoggedIn ? <ActionsDispatcher /> : null}
      {shouldShowSAPDownTimePopup && <SAPDownTime />}
      {isLoggedIn && isAddProductToWishlistModalVisible ? <AddProductToWishListModal /> : null}
      <ScrollToTop />
      <RouterRenderer />
    </Layout>
  )
}

export default App
